import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import Reserve from './pages/Reserve/Reserve';
import Sterling from './pages/Sterling';
import FindYourCity from './pages/FindYourCity';
import HowItWorks from './pages/HowItWorks';

function App() {
  return (
    <HashRouter>
      <div className="min-h-screen flex flex-col font-body selection:bg-retro-yellow selection:text-retro-brown">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/reserve" element={<Reserve />} />
            <Route path="/sterling" element={<Sterling />} />
            <Route path="/find-your-city" element={<FindYourCity />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </HashRouter>
  );
}

export default App;